<template>
  <v-layout data-qa="changetemppassword-layout-kvy51r">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="changetemppassword-overlay-rf6t3cw">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="changetemppassword-progress-circular-y0wmlt"></v-progress-circular>
    </v-overlay>
    <v-flex xs12 sm12 md12 lg12 xl12 data-qa="changetemppassword-flex-lzslf">
      <v-card-subtitle v-if="showNewPasswordSection" data-qa="changetemppassword-card-subtitle-qck5h5">
        {{ currentSubTitle }}
      </v-card-subtitle>
      <!-- Common Set Password Component -->
      <SetPassword
        v-if="showNewPasswordSection"
        :config="{
          enableUserId: true,
          enableLoginId: false,
          enableOldPassword: true,
          userID: userLoginID,
          roundedPwdBtn: true,
          enableOtpModal: false,
          showSuccessModal: false,
          btnLabel: $t('changePassword.button.nextBtn'),
          fromScreen: 'changePassword',
        }"
      />
    </v-flex>
    <!-- Password set status -->
    <v-flex v-if="showPasswordResetSuccess" xl12 data-qa="changetemppassword-flex-0enpah">
      <p data-qa="changetemppassword-p-fik3pe">
        <inline-svg
          v-if="passwordChangeStatus"
          :src="getTickIcon()"
          width="90"
          height="90"
          aria-label="Tick Icon"
          data-qa="pwd-success"
        ></inline-svg>
        <v-icon v-else size="80" :color="errorColor" data-qa="pwd-failure">{{
          passwordChangeStatusIcon
        }}</v-icon>
      </p>
      <p class="subtitle-1 font-weight-medium" data-qa="changetemppassword-p-aaslvf">
        {{ passwordChangeStatusMsg }}
      </p>
      <v-card-actions class="pa-0" data-qa="changetemppassword-card-actions-c9fcfa">
        <v-btn
          @click="goBackToLoginScreen"
          :color="primaryColor"
          data-qa="savePassword"
          class="text-capitalize white--text py-2 px-4"
          >{{ $t("common.goToLoginLabel") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import event from '@/util/event'
import CommonService from '@/service/commonService.js'
import handleError from '../../core/_helpers/errorHandler'
import SetPassword from '@/components/DOB-SetPassword/SetPassword.vue'

export default {
  name: 'changeTemporaryPassword',
  components: {
    SetPassword
  },
  props: {
    objData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      newPassword: '',
      userLoginID: '',
      oldPassword: '',
      currentSubTitle: '',
      passwordChangeStatusMsg: '',
      passwordChangeStatusIcon: '',
      loaderEnabled: false,
      passwordChangeStatus: false,
      showPasswordResetSuccess: false,
      showNewPasswordSection: true,
      otpData: {},
      enableOTP:
        this.$appSettings.defaultConfigurations.loginPageScreens.changeExpiredOrTempPassword.enableOTP
    }
  },
  created () {
    this.currentSubTitle = this.$t(
      `login.actionScreen.subHeadings.${this.objData?.subType}`
    )
    this.userLoginID = this.objData?.loginID
    event.$on('resetPwdSuccess', (args) => {
      if (args.status) {
        this.otpData = args.otpData
        this.newPassword = args.password
        this.oldPassword = args.oldPassword
        this.changePassword()
      }
    })
  },
  methods: {
    goBackToLoginScreen () {
      event.$emit('goBackToLoginScreen', true)
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    onResetPassword () {
      this.showOTPSection = false
      this.showNewPasswordSection = false
      this.showPasswordResetSuccess = true
    },
    onResetFailed () {
      event.$emit('resetPasswordFailed')
    },
    async changePassword () {
      try {
        this.loaderEnabled = true
        const passwordPayload = {
          ...this.otpData,
          userLoginId: this.userLoginID,
          newPassword: this.newPassword,
          oldPassword: this.oldPassword,
          authenticationMethod: 'LOGINID_PASSWORD',
          channelMode: 'WEB'
        }
        const status = await CommonService.changeExpiredOrTempPassword(
          passwordPayload
        )
        if (status.data && !status.error) {
          this.passwordChangeStatus = true
          this.passwordChangeStatusIcon = 'mdi-checkbox-marked-circle-outline'
          this.passwordChangeStatusMsg = this.$t(
            'forgotPassword.resetPasswordSuccess'
          )
          this.loaderEnabled = false
        } else {
          if (
            status.error.response.data && status.error.response.data.causes && ['FEUS-000039'].includes(
              status.error.response.data.causes[0].code
            ) // FEUS-000039 - OTP entered is invalid
          ) {
            event.$emit('prelogin_invalid_otp')
            this.loaderEnabled = false
            return
          } else if (
            status.error.response.data && status.error.response.data.causes && status.error.response.data.causes[0].code === 'FEUS-000027'
          ) {
            handleError(status.error)
            event.$emit('reset_OTPField', true)
            this.loaderEnabled = false
            return
          } else if (
            status.error.response.data && status.error.response.data.causes && ['FEUS-000068', 'FEUS-000071'].includes(status.error.response.data.causes[0].code)
          ) {
            // 000068 - Pwd shouldn't match with the most recent pwd
            // 000071 - New password cannot be identical to the last 5 passwords/ most recent password - We need to retrigger the otp in this case
            event.$emit('prelogin_resend_otp', true)
            handleError(status.error)
            this.loaderEnabled = false
          } else {
            handleError(status.error)
            event.$emit('reset_OTPField', true)
            event.$emit('prelogin_resend_otp', true)
            this.passwordChangeStatus = false
            this.passwordChangeStatusIcon = 'mdi-close-circle-outline'
            this.passwordChangeStatusMsg = this.$t(
              'forgotPassword.resetPasswordFailure'
            )
          }
        }
        this.passwordChangeStatus
          ? this.onResetPassword()
          : this.onResetFailed()
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    }
  },
  beforeDestroy () {
    event.$off('resetPwdSuccess')
    event.$off('checkLoginScreenAction')
  }
}
</script>
